import { Sprite as $Sprite } from 'pixi.js'

class Sprite extends $Sprite {
  constructor(texture) {
    super(texture)

    this.on('added', this.onAdded, this)
    this.on('removed', this.onRemoved, this)
  }

  onAdded() {}

  onRemoved() {}
}

export default Sprite
